import { useEffect, useState, useCallback } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import api from "@/lib/api";

export default function PopupManager() {
  const [popups, setPopups] = useState([]);
  const [open, setOpen] = useState(false);
  const [idx, setIdx] = useState(0);

  const fetchPopups = useCallback(async () => {
    try {
      const { data } = await api.get("/popups");
      if (data.length > 0) {
        const seen = sessionStorage.getItem("bistrot_popup_seen");
        if (!seen) {
          setPopups(data);
          setOpen(true);
          sessionStorage.setItem("bistrot_popup_seen", "1");
        }
      }
    } catch {}
  }, []);

  useEffect(() => { fetchPopups(); }, [fetchPopups]);

  const current = popups[idx];
  if (!current) return null;

  const onClose = () => {
    if (idx < popups.length - 1) setIdx(idx + 1);
    else setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent
        data-testid="popup-modal"
        className="bg-[#FDFBF7] border border-[#E5E0D8] rounded-none max-w-lg"
      >
        <DialogHeader>
          <DialogTitle className="font-serif text-3xl text-[#1A1A1A]" data-testid="popup-title">{current.titre}</DialogTitle>
        </DialogHeader>
        <DialogDescription className="text-base text-[#1A1A1A]/80 whitespace-pre-wrap leading-relaxed">
          {current.contenu}
        </DialogDescription>
      </DialogContent>
    </Dialog>
  );
}
